export const NAV = [
  { label: "Home", to: "/", id: "home" },
  { label: "The Program", to: "/program", id: "program" },
  { label: "Partnerships & Pilot", to: "/partnerships", id: "partnerships" },
  { label: "Who It Serves", to: "/who-it-serves", id: "serves" },
  { label: "About John", to: "/about", id: "about" },
  { label: "Resources & FAQ", to: "/resources", id: "resources" },
  { label: "Contact", to: "/contact", id: "contact" },
];

export const DOC_URL = "https://vimeo.com/ondemand/thejohnmasonstory/1144389911";
export const SHOP_URL = "https://the-journey-of-life.printify.me/";
export const DOC_EMBED = "https://player.vimeo.com/video/1144389911?dnt=1&title=0&byline=0&portrait=0&color=F3C649";

export const CONTACT = {
  email: "jem.partnerships@gmail.com",
  phone: "+1 (678) 310-2630",
  tel: "+16783102630",
};
